<template >
  <base-dialog-form :type="type" ref="editDisciplineDialog" :title="computedTitle" color="secondary" icon="mdi-bank">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveDiscipline" color="success">{{ $t("save") }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-container>
      <v-row>
        <v-col cols="12" class="text-center">
          <DataTables itemKey="idDisciplina" :selectedValue="selectedValue" v-model="selected"
            :showSelect="method === 'EDIT'" :headers="headers" :tableData="tableData"></DataTables>
        </v-col>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import DataTables from "@/components/base/DataTables.vue";

export default {
  name: "edit-discipline",
  components: {
    DataTables,
  },
  props: {
    type: {
      type: String, // not 'string'
      required: false,
      default: "dialog",
    },
    parmsMethod: {
      type: String, // not 'string'
      required: false,
    },
  },

  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("manage_disciplines")+" "+this.code;
      else if (this.method === "VIEW") return this.$t("view_disciplines")+" "+this.code;
      else return "";
    },
  },
  data() {
    return {
      method: null,
      code: null,
      headers: [{ text: this.$t("disciplines"), value: "descr" }],
      tableData: [],
      selected: [],
      selectedValue: [],
      required: [(value) => !!value || "Required."],
      requiredNumber: [(value) => (!!value && !isNaN(value)) || "Required."],
    };
  },
  methods: {
    open(method, code) {
      this.method = method;
      this.code = code;
      this.loadTable();
      this.$refs.editDisciplineDialog.open();
    },
    loadTable() {
      let _ = this;
      let now = new Date();
      _.tableData = [];
      _.selectedValue = [];
      let filter = {};
      if (_.method === "EDIT") filter = { onlyActive: false };
      this.chiamataAxios("GET", "/auth/ente/listDiscipline/" + _.code, {
        body: { filter: filter },
      }).then((response) => {
        _.tableData = response.data;
        _.selectedValue = response.data.filter((disciplina) => {
          return disciplina.attiva === 1;
        });
      });
    },

    saveDiscipline: function () {
      let _ = this;

      _.chiamataAxios("PUT", "/auth/ente/saveDiscipline/", {
        dialogLoader: true,
        body: _.selected,
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$refs.editDisciplineDialog.close();
          _.loadTable();
          _.$emit("isUpdated", "true");
        }
      });
    },
  },
  mounted() {
    this.method = this.parmsMethod;
    this.loadTable();
  },
  watch: {
    code: function (newVal, oldVal) {
      // watch it
      this.loadTable();
    },
    parmsMethod: function (newVal, oldVal) {
      // watch it
      this.method = newVal;
    },
  },
};
</script>